<script setup lang="ts">
import { UiButton, UiFieldContainer, UiIcon, UiInfoBox, UiText, useToaster } from "@shopexperts/shared";

const props = withDefaults(defineProps<{
    accessKey: string;
    title?: string;
    description?: string;
    highlight?: boolean;
}>(), {
    title: "Access key",
    description: "Use this key to authenticate contact submissions from the satellite site.",
    highlight: false,
});

const toaster = useToaster();

async function copyAccessKey() {
    if (!props.accessKey || !navigator.clipboard) return;
    await navigator.clipboard.writeText(props.accessKey);
    toaster.create({
        title: "Access key copied",
        type: "success",
    });
}
</script>

<template>
    <UiInfoBox
        v-if="highlight"
        variant="warning"
        title="Key updated"
    >
        <UiText
            as="p"
            variant="p-small"
            class="text-amber-900/90"
            :text="description"
        />
    </UiInfoBox>
    <UiText
        v-else-if="description"
        as="p"
        variant="p-small"
        class="text-se-gray-600"
        :text="description"
    />

    <div class="flex flex-col gap-1">
        <UiText as="label" variant="p-small" class="font-semibold text-se-dark" :text="title" />
        <UiFieldContainer gap="0" class="overflow-hidden pr-0">
            <code class="min-w-0 flex-1 truncate px-1 py-2 font-mono text-sm text-se-dark">
                {{ accessKey }}
            </code>
            <UiButton
                variant="ghost"
                label="Copy"
                class="-my-px self-stretch rounded-none border-l border-se-gray-300 px-4 hover:bg-se-gray-100"
                @click="copyAccessKey"
            >
                <template #before_label>
                    <UiIcon name="copy" class="h-5 w-5" />
                </template>
            </UiButton>
        </UiFieldContainer>
    </div>
</template>
